import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../../CartContext";

const HomeFeaturedProducts = () => {
  const { cart, addToCart, decreaseQuantity } = useCart();
  const [tab, setTab] = useState("All");
  const [allProducts, setAllProducts] = useState([]);
  const [products, setProducts] = useState([]);

  const tabs = [
    "All",
    "Laptop",
    "Phones",
    "Appliances",
    "Accessories",
    "Games",
  ];
  useEffect(() => {
    fetch("products.json")
      .then((res) => res.json())
      .then((data) => {
        setAllProducts(data);
        setProducts(data);
      });
  }, []);

  const filteredProducts = (category) => {
    setTab(category);
    if (category === "All") {
      setProducts(allProducts);
    } else {
      const updatedProducts = allProducts.filter((p) => {
        return p.category === category;
      });
      setProducts(updatedProducts);
    }
  };
  return (
    <div className="my-[80px] flex flex-col items-center justify-center">
      {/* Featured Products Banner */}
      <div className="shadow-md shadow-gray-300 flex items-center justify-center lg:justify-between w-[90%] py-[20px] px-[10px] lg:px-[30px] rounded-[5px]">
        <h2 className="font-[700] text-[18px]">FEATURED PRODUCTS</h2>
        {/* Tabs */}
        <div className="hidden lg:flex items-center gap-3">
          {tabs.map((tb, i) => (
            <button
              key={i}
              className={`py-[5px] px-[10px] rounded-[5px] font-[600] text-[14px] transition-all duration-500 ease-in-out ${
                tab === tb ? "bg-amber-500 text-white" : ""
              }`}
              onClick={() => {
                filteredProducts(tb);
              }}
            >
              {tb.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
      {/* Show Products */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-[50px] gap-4">
        {products.slice(0, 8).map((product) => {
          const inCart = cart.find((item) => item.id === product.id);

          return (
            <div
              key={product.id}
              className="relative border-[1px] border-gray-300 py-[10px] rounded-[5px] text-center"
            >
              <NavLink
                to={`shop/${product.id}`}
                onClick={() => window.scrollTo({ top: 0 })}
              >
                <img
                  src={product.image}
                  alt={product.id}
                  className="h-[300px] lg:h-[250px] transition-all duration-700 ease-in-out hover:scale-110"
                />
              </NavLink>
              <div>
                <i class="fa-regular fa-heart absolute top-[5%] left-[80%] bg-gray-200 p-[9px] rounded-full text-[13px] hover:bg-amber-500 hover:text-white cursor-pointer"></i>
                <NavLink
                  onClick={() => {
                    window.scrollTo({ top: 0 });
                  }}
                  to={`shop/${product.id}`}
                >
                  <h3 className="font-[600] text-[18px] py-[5px]">
                    {product.name}
                  </h3>
                  <p className="text-gray-500 text-[12px] font-[600] pb-[10px]">
                    {product.category}
                  </p>
                </NavLink>
                <div>
                  {inCart && inCart.quantity > 0 ? (
                    <div className="flex items-center justify-between px-[15px] font-[600]">
                      {inCart && inCart.quantity > 0 ? (
                        <NavLink
                          className={
                            "text-[12px] font-[600] text-gray-600 hover:text-amber-500 py-[5px] px-[10px] rounded-[5px]"
                          }
                          to={"/cart-page"}
                          onClick={() => {
                            window.scrollTo({ top: 0 });
                          }}
                        >
                          VIEW IN CART
                        </NavLink>
                      ) : (
                        <div>
                          <span className="font-[600] text-[14px] text-gray-600">
                            ${product.price.toFixed(2)}
                          </span>
                        </div>
                      )}
                      <div className="w-[50%] flex items-center justify-end">
                        <button
                          className={`${
                            inCart.quantity <= 1
                              ? "bg-gray-500"
                              : "bg-amber-500"
                          } text-white p-[5px] w-[40px]`}
                          onClick={() => decreaseQuantity(product.id)}
                        >
                          -
                        </button>
                        <span className="w-[40px]">{inCart.quantity}</span>
                        <button
                          className="bg-amber-500 text-white p-[5px] w-[40px]"
                          onClick={() => addToCart(product)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-between px-[15px] relative">
                      <span className="font-[600] text-[14px] text-gray-600">
                        ${product.price.toFixed(2)}
                      </span>
                      <span className="absolute left-[50%] translate-x-[-50%]">
                        |
                      </span>
                      <button
                        onClick={() => addToCart(product)}
                        className="font-[600] text-[14px] text-gray-600 hover:text-amber-500"
                      >
                        ADD TO CART
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <NavLink
        onClick={() => {
          window.scrollTo({ top: 0 });
        }}
        to={"/shop"}
        className="relative top-[10px] mb-[70px] border-[1px] border-slate-300 rounded-[5px] py-[10px] px-[20px] hover:bg-amber-500 text-[16px] font-[600]"
      >
        VIEW ALL PRODUCTS{" "}
        <i className="fa-solid fa-arrow-up-right-from-square"></i>
      </NavLink>
    </div>
  );
};

export default HomeFeaturedProducts;
